/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询东艺公告咨询或媒体报道
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetDongYiNewsOrNoticeParams {
  constructor(public typeId: string) {}
}

export default async function (
  params: GetDongYiNewsOrNoticeParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.TheaterNewsDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/theater/dongyi-notices`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
